module.exports = __webpack_public_path__ + "static/media/pacific-rim.9d71e7eb.jpg";